import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TaxProfileService } from '../services/tax-profile.service';

export const requireNoTaxProfileGuard: CanActivateFn = (route, state) => {
  const taxProfileService = inject(TaxProfileService);
  const router = inject(Router);

  return !taxProfileService.profile() ? true : router.createUrlTree(['/collaboration/profile']);
};
